import { useEffect, memo } from 'react'
import { useHistory } from 'react-router'
import { decodeToken } from 'react-jwt'

import { useQuery } from 'custom-hooks/useQuery'

const HandleRestoreLink = () => {
  const history = useHistory()
  const query = useQuery()
  const _token = query.get('token')
  const code = query.get('code')

  const { email } = decodeToken(_token) || {}

  useEffect(() => {
    if (code && email) {
      history.push('/auth/confirm-restore-password', {
        confirmCode: code,
        userName: email,
      })
    } else {
      history.push('/')
    }
  }, [code, email, history])

  return null
}

export default memo(HandleRestoreLink)
